
const WhyChooseUs = () => {
  const features = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Licensed & Insured',
      description: 'Fully licensed electrical contractor with comprehensive insurance coverage for your peace of mind.',
    },
    {
      icon: 'ri-checkbox-circle-fill',
      title: 'Australian Standards',
      description: 'All work completed to AS/NZS 3000 standards with full compliance certification.',
    },
    {
      icon: 'ri-time-fill',
      title: 'Prompt & Reliable',
      description: 'We value your time. Quick response times and efficient project completion.',
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Transparent Pricing',
      description: 'Clear, upfront quotes with no hidden fees. You know exactly what you\'re paying for.',
    },
    {
      icon: 'ri-star-fill',
      title: 'Quality Focused',
      description: 'Committed to delivering exceptional workmanship on every project, big or small.',
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Dedicated Support',
      description: 'Direct communication with our team. We\'re here to answer your questions and address your needs.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-navy mb-4">WHY CHOOSE NS ELECTRICAL WA</h2>
          <div className="h-1 w-32 bg-gold mx-auto mb-6"></div>
          <p className="text-charcoal text-lg max-w-2xl mx-auto">
            A fresh approach to electrical services with a commitment to quality, safety, and customer satisfaction
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-gold"
            >
              <div className="w-16 h-16 bg-navy rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-gold text-3xl w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy mb-3">{feature.title}</h3>
              <p className="text-charcoal leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
